// A "group only" module is a sidebar heading with no page of its own —
// e.g. "MarketSync Dropshipping", whose dashboard is now its own
// "MarketSync Dashboard" sub-module. It is marked is_category AND actually
// has sub-modules in the user's list. (Some real leaf pages carry a stray
// is_category flag in existing data — those still count as pages, since
// they have no children.)
//
// Used so a group's placeholder route_path is never picked as the landing
// page after login and never counts as an accessible URL in the route guards.
export function isGroupOnlyModule(module, modules) {
  if (module?.is_group) return true; // a main module (folder) never has a page, even before its first sub-module exists
  if (!module?.is_category) return false;
  const id = String(module.moduleId || module._id);
  return (modules || []).some((m) => m.parent_id && String(m.parent_id) === id);
}
